import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_2 = { class: "sticky top-0 bg-white border-b border-dashboard-border p-6 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_5 = { class: "text-xl font-bold text-dashboard-text" }
const _hoisted_6 = { class: "text-sm text-dashboard-muted" }
const _hoisted_7 = {
  key: 0,
  class: "mx-6 mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3"
}
const _hoisted_8 = { class: "text-sm text-red-600" }
const _hoisted_9 = {
  key: 1,
  class: "mx-6 mt-4 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start gap-3"
}
const _hoisted_10 = { class: "text-sm text-green-800" }
const _hoisted_11 = { class: "text-sm font-semibold text-dashboard-text mb-4 flex items-center gap-2" }
const _hoisted_12 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_13 = { class: "hidden" }
const _hoisted_14 = { class: "text-sm font-semibold text-dashboard-text mb-4 flex items-center gap-2" }
const _hoisted_15 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "relative"
}
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = ["disabled", "placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "absolute z-50 w-full mt-1 bg-white border border-dashboard-border rounded-lg shadow-lg max-h-60 overflow-y-auto"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "font-medium text-dashboard-text" }
const _hoisted_23 = { class: "text-xs text-dashboard-muted" }
const _hoisted_24 = {
  key: 1,
  class: "mt-2 inline-flex items-center gap-2 px-3 py-1 bg-[#22282F]/10 text-[#22282F] rounded-lg text-sm"
}
const _hoisted_25 = {
  key: 1,
  class: "relative"
}
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "absolute z-50 w-full mt-1 bg-white border border-dashboard-border rounded-lg shadow-lg max-h-60 overflow-y-auto"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "font-medium text-dashboard-text" }
const _hoisted_31 = { class: "text-xs text-dashboard-muted" }
const _hoisted_32 = {
  key: 1,
  class: "mt-2 inline-flex items-center gap-2 px-3 py-1 bg-[#22282F]/10 text-[#22282F] rounded-lg text-sm"
}
const _hoisted_33 = {
  key: 2,
  class: "mt-1 text-xs text-dashboard-muted"
}
const _hoisted_34 = {
  key: 2,
  class: "relative md:col-span-2"
}
const _hoisted_35 = { class: "relative" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "absolute z-50 w-full mt-1 bg-white border border-dashboard-border rounded-lg shadow-lg max-h-60 overflow-y-auto"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "font-medium text-dashboard-text" }
const _hoisted_40 = { class: "text-xs text-dashboard-muted" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "mt-2 inline-flex items-center gap-2 px-3 py-1 bg-[#22282F]/10 text-[#22282F] rounded-lg text-sm"
}
const _hoisted_43 = {
  key: 2,
  class: "mt-1 text-xs text-dashboard-muted"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "text-sm font-semibold text-dashboard-text mb-1 flex items-center gap-2" }
const _hoisted_46 = { class: "grid grid-cols-2 gap-2 mb-4" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "text-sm font-semibold text-dashboard-text mb-4 flex items-center gap-2" }
const _hoisted_51 = {
  key: 0,
  class: "flex items-center gap-3 cursor-pointer"
}
const _hoisted_52 = { class: "flex gap-3 pt-4 border-t border-dashboard-border" }
const _hoisted_53 = ["disabled"]

import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { 
  X, User, UserPlus, Edit3, Briefcase, Settings, 
  AlertCircle, CheckCircle2, Save, Loader2, Search, Building2
} from 'lucide-vue-next'
import { apiFetch } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'
import { useAuthStore } from '@/store/auth'

interface Props {
  isOpen: boolean
  userId?: number | null
}

interface Emits {
  (e: 'close'): void
  (e: 'success'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserFormModal',
  props: {
    isOpen: { type: Boolean },
    userId: {}
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const toast = useToast()

const props = __props
const emit = __emit
const authStore = useAuthStore()

const loading = ref(false)
const error = ref('')
const success = ref('')

// Searchable dropdowns state
const searchDirection = ref('')
const searchDepartement = ref('')
const searchService = ref('')
const showDirectionDropdown = ref(false)
const showDepartementDropdown = ref(false)
const showServiceDropdown = ref(false)
const selectedDirection = ref<any>(null)
const selectedDepartement = ref<any>(null)
const selectedService = ref<any>(null)

const form = ref({
  username: '',
  email: '',
  first_name: '',
  last_name: '',
  password: '',
  confirm_password: '',
  is_active: true,
  profile: {
    role_id: '',
    direction_id: '',
    ambassade_id: '',
    departement_id: '',
    service_id: '',
    matricule: '',
    telephone: '',
    poste: '',
    backoffice_permissions: { sections: [] as string[], actions: [] as string[] }
  }
})

// Permissions backoffice (attribution par un administrateur plein)
const permsCatalog = ref<{ sections: any[]; actions: any[] }>({ sections: [], actions: [] })
const canManagePermissions = computed(() => authStore.isFullBackoffice())

const roles = ref<any[]>([])
const directions = ref<any[]>([])
const departements = ref<any[]>([])
const services = ref<any[]>([])

const currentAdmin = computed(() => authStore.user)
const isAmbassadeScopedAdmin = computed(() => {
  const roleCode = currentAdmin.value?.role?.code
  return roleCode === 'AMBASSADEUR' && !!currentAdmin.value?.ambassade
})
const adminDirection = computed(() => {
  const roleCode = currentAdmin.value?.role?.code
  if (!currentAdmin.value?.direction) return null
  return roleCode === 'ADMIN' || roleCode === 'DIRECTEUR' ? currentAdmin.value.direction : null
})
const isDirectionScopedAdmin = computed(() => Boolean(adminDirection.value))

const availableRoles = computed(() => {
  const roleCode = currentAdmin.value?.role?.code
  if (isAmbassadeScopedAdmin.value) {
    return roles.value.filter(role => role.code === 'AGENT')
  }
  if (!isDirectionScopedAdmin.value) return roles.value

  if (roleCode === 'DIRECTEUR') {
    const allowedCodes = new Set(['CHEF_DEPT', 'CHEF_SERVICE', 'AGENT'])
    return roles.value.filter(role => allowedCodes.has(role.code))
  }

  return roles.value
})

const availableDirections = computed(() => {
  if (!isDirectionScopedAdmin.value || !adminDirection.value) return directions.value
  const scopedDirection = adminDirection.value
  if (!scopedDirection) return directions.value
  return directions.value.filter(direction => direction.id === scopedDirection.id)
})

const filteredDepartements = computed(() => {
  // Si aucune direction sélectionnée, afficher tous les départements
  if (!form.value.profile.direction_id) return departements.value
  
  // Filtrer les départements par direction
  return departements.value.filter(dept => {
    if (!dept.direction) return false
    return dept.direction.id === parseInt(form.value.profile.direction_id)
  })
})

const filteredServices = computed(() => {
  // Si un département est sélectionné, filtrer par département
  if (form.value.profile.departement_id) {
    return services.value.filter(service => {
      if (!service.departement) return false
      return service.departement.id === parseInt(form.value.profile.departement_id)
    })
  }
  
  // Sinon, si une direction est sélectionnée, filtrer par direction
  if (form.value.profile.direction_id) {
    return services.value.filter(service => {
      if (!service.direction) return false
      return service.direction.id === parseInt(form.value.profile.direction_id)
    })
  }
  
  // Sinon afficher tous les services
  return services.value
})

// Computed pour la recherche des directions
const filteredDirectionsSearch = computed(() => {
  if (!searchDirection.value) return availableDirections.value
  
  const query = searchDirection.value.toLowerCase()
  return availableDirections.value.filter(dir =>
    dir.nom.toLowerCase().includes(query) ||
    dir.code.toLowerCase().includes(query)
  )
})

// Computed pour la recherche des départements
const filteredDepartementsSearch = computed(() => {
  let result = filteredDepartements.value
  
  if (searchDepartement.value) {
    const query = searchDepartement.value.toLowerCase()
    result = result.filter(dept =>
      dept.nom.toLowerCase().includes(query) ||
      dept.code.toLowerCase().includes(query)
    )
  }
  
  return result
})

// Computed pour la recherche des services
const filteredServicesSearch = computed(() => {
  let result = filteredServices.value
  
  if (searchService.value) {
    const query = searchService.value.toLowerCase()
    result = result.filter(service =>
      service.nom.toLowerCase().includes(query) ||
      service.code.toLowerCase().includes(query) ||
      (service.departement && service.departement.nom.toLowerCase().includes(query))
    )
  }
  
  return result
})

// Fonctions de sélection
const selectDirection = (dir: any) => {
  if (isDirectionScopedAdmin.value && adminDirection.value && dir.id !== adminDirection.value.id) {
    return
  }
  selectedDirection.value = dir
  form.value.profile.direction_id = String(dir.id)
  searchDirection.value = ''
  showDirectionDropdown.value = false
  
  // Reset département et service
  clearDepartement()
  clearService()
}

const clearDirection = () => {
  if (isDirectionScopedAdmin.value && adminDirection.value) {
    selectedDirection.value = adminDirection.value
    form.value.profile.direction_id = String(adminDirection.value.id)
    searchDirection.value = adminDirection.value.nom
    return
  }
  selectedDirection.value = null
  form.value.profile.direction_id = ''
  searchDirection.value = ''
  
  // Reset département et service
  clearDepartement()
  clearService()
}

const selectDepartement = (dept: any) => {
  selectedDepartement.value = dept
  form.value.profile.departement_id = String(dept.id)
  searchDepartement.value = ''
  showDepartementDropdown.value = false
  
  // Reset service
  clearService()
}

const clearDepartement = () => {
  selectedDepartement.value = null
  form.value.profile.departement_id = ''
  searchDepartement.value = ''
  
  // Reset service
  clearService()
}

const selectService = (service: any) => {
  selectedService.value = service
  form.value.profile.service_id = String(service.id)
  searchService.value = ''
  showServiceDropdown.value = false
}

const clearService = () => {
  selectedService.value = null
  form.value.profile.service_id = ''
  searchService.value = ''
}

const generateUsername = () => {
  if (!props.userId && form.value.email) {
    // Extraire la partie avant le @ de l'email
    const emailParts = form.value.email.split('@')
    if (emailParts.length > 0) {
      form.value.username = emailParts[0].toLowerCase()
    }
  }
}

const fetchRoles = async () => {
  try {
    roles.value = await apiFetch('/api/admin/roles/')
  } catch (e: any) {
    toast.error('Erreur', 'Impossible de charger les rôles')
  }
}

const fetchDirections = async () => {
  try {
    directions.value = await apiFetch('/api/admin/directions/')
    if (adminDirection.value) {
      searchDirection.value = adminDirection.value.nom
      selectedDirection.value = adminDirection.value
      form.value.profile.direction_id = String(adminDirection.value.id)
    }
  } catch (e: any) {
    toast.error('Erreur', 'Impossible de charger les directions')
  }
}

const fetchDepartements = async () => {
  try {
    departements.value = await apiFetch('/api/admin/departements/')
  } catch (e: any) {
    toast.error('Erreur', 'Impossible de charger les départements')
  }
}

const fetchServices = async () => {
  try {
    services.value = await apiFetch('/api/admin/services/')
  } catch (e: any) {
    toast.error('Erreur', 'Impossible de charger les services')
  }
}

const fetchUserData = async () => {
  if (!props.userId) return
  
  try {
    const user = await apiFetch(`/api/admin/users/${props.userId}/`)
    
    form.value = {
      username: user.username,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      password: '',
      confirm_password: '',
      is_active: user.is_active,
      profile: {
        role_id: user.profile?.role_id ? String(user.profile.role_id) : '',
        direction_id: user.profile?.direction_id ? String(user.profile.direction_id) : '',
        ambassade_id: user.profile?.ambassade_id ? String(user.profile.ambassade_id) : '',
        departement_id: user.profile?.departement_id ? String(user.profile.departement_id) : '',
        service_id: user.profile?.service_id ? String(user.profile.service_id) : '',
        matricule: user.profile?.matricule || '',
        telephone: user.profile?.telephone || '',
        poste: user.profile?.poste || '',
        backoffice_permissions: {
          sections: [...(user.profile?.backoffice_permissions?.sections || [])],
          actions: [...(user.profile?.backoffice_permissions?.actions || [])]
        }
      }
    }
    
    // Pré-remplir les objets sélectionnés pour l'affichage
    if (user.direction) {
      selectedDirection.value = user.direction
      searchDirection.value = user.direction.nom
    }
    if (user.departement) {
      selectedDepartement.value = user.departement
    }
    if (user.service) {
      selectedService.value = user.service
    }
  } catch (e: any) {
    error.value = e.message || 'Erreur lors du chargement de l\'utilisateur'
    toast.error('Erreur', error.value)
  }
}

const resetForm = () => {
  form.value = {
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    confirm_password: '',
    is_active: true,
    profile: {
      role_id: '',
      direction_id: '',
      ambassade_id: '',
      departement_id: '',
      service_id: '',
      matricule: '',
      telephone: '',
      poste: '',
      backoffice_permissions: { sections: [] as string[], actions: [] as string[] }
    }
  }
  error.value = ''
  success.value = ''
  
  // Reset searchable dropdowns
  searchDirection.value = adminDirection.value?.nom || ''
  searchDepartement.value = ''
  searchService.value = ''
  showDirectionDropdown.value = false
  showDepartementDropdown.value = false
  showServiceDropdown.value = false
  selectedDirection.value = null
  selectedDepartement.value = null
  selectedService.value = null

  if (adminDirection.value) {
    selectedDirection.value = adminDirection.value
    form.value.profile.direction_id = String(adminDirection.value.id)
  }
}

const handleClose = () => {
  resetForm()
  emit('close')
}

const handleSubmit = async () => {
  error.value = ''
  success.value = ''
  
  loading.value = true

  try {
    if (!props.userId) {
      if (!form.value.password || !form.value.confirm_password) {
        throw new Error('Le mot de passe et sa confirmation sont obligatoires')
      }
      if (form.value.password !== form.value.confirm_password) {
        throw new Error('Les mots de passe ne correspondent pas')
      }
    }

    // Préparer les données
    const payload: any = {
      email: form.value.email,
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      is_active: props.userId ? form.value.is_active : true,
      profile: {
        role_id: form.value.profile.role_id || null,
        direction_id: form.value.profile.direction_id || null,
        ambassade_id: form.value.profile.ambassade_id || null,
        departement_id: form.value.profile.departement_id || null,
        service_id: form.value.profile.service_id || null,
        matricule: form.value.profile.matricule || '',
        telephone: form.value.profile.telephone || '',
        poste: form.value.profile.poste || ''
      }
    }

    // Permissions backoffice : envoyées seulement par un administrateur plein.
    if (canManagePermissions.value) {
      payload.profile.backoffice_permissions = {
        sections: form.value.profile.backoffice_permissions?.sections || [],
        actions: form.value.profile.backoffice_permissions?.actions || []
      }
    }

    if (isAmbassadeScopedAdmin.value) {
      payload.profile.ambassade_id = currentAdmin.value?.ambassade?.id || null
      payload.profile.direction_id = null
      payload.profile.departement_id = null
      payload.profile.service_id = null
    }

    if (!props.userId) {
      // Création
      payload.username = form.value.username
      payload.password = form.value.password

      if (isAmbassadeScopedAdmin.value) {
        payload.profile.ambassade_id = currentAdmin.value?.ambassade?.id || null
        payload.profile.direction_id = null
        payload.profile.departement_id = null
        payload.profile.service_id = null
      }
      
      await apiFetch('/api/admin/users/create/', {
        method: 'POST',
        body: JSON.stringify(payload)
      })
      
      toast.success('Utilisateur créé', 'L\'utilisateur a été créé avec succès')
    } else {
      // Mise à jour
      await apiFetch(`/api/admin/users/${props.userId}/update/`, {
        method: 'PUT',
        body: JSON.stringify(payload)
      })
      
      toast.success('Utilisateur modifié', 'Les informations ont été mises à jour avec succès')
    }

    setTimeout(() => {
      emit('success')
      handleClose()
    }, 500)

  } catch (e: any) {
    error.value = e.message || 'Une erreur est survenue'
    toast.error('Erreur', error.value)
  } finally {
    loading.value = false
  }
}

watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    if (props.userId) {
      fetchUserData()
    } else {
      resetForm()
    }
  }
})

// Fermer les dropdowns quand on clique en dehors
const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  if (!target.closest('.relative')) {
    showDirectionDropdown.value = false
    showDepartementDropdown.value = false
    showServiceDropdown.value = false
  }
}

const fetchPermsCatalog = async () => {
  try {
    permsCatalog.value = await apiFetch('/api/admin/permissions/catalog/')
  } catch (e) {
    // silencieux : la section Permissions ne s'affichera pas
  }
}

onMounted(() => {
  fetchRoles()
  if (!isAmbassadeScopedAdmin.value) {
    fetchDirections()
    fetchDepartements()
    fetchServices()
  }
  if (canManagePermissions.value) {
    fetchPermsCatalog()
  }

  // Ajouter le listener pour fermer les dropdowns
  document.addEventListener('click', handleClickOutside)
})

// Nettoyer le listener lors de la destruction du composant
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50",
          onClick: _withModifiers(handleClose, ["self"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (!_ctx.userId)
                    ? (_openBlock(), _createBlock(_unref(UserPlus), {
                        key: 0,
                        class: "w-6 h-6 text-[#22282F]"
                      }))
                    : (_openBlock(), _createBlock(_unref(Edit3), {
                        key: 1,
                        class: "w-6 h-6 text-[#22282F]"
                      }))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.userId ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.userId ? 'Mettre à jour les informations' : 'Créer un nouveau compte utilisateur'), 1)
                ])
              ]),
              _createElementVNode("button", {
                onClick: handleClose,
                class: "p-2 hover:bg-dashboard-bg rounded-lg transition-colors"
              }, [
                _createVNode(_unref(X), { class: "w-5 h-5 text-dashboard-muted" })
              ])
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(AlertCircle), { class: "w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" }),
                  _createElementVNode("div", null, [
                    _cache[22] || (_cache[22] = _createElementVNode("p", { class: "font-medium text-red-800" }, "Erreur", -1)),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(error.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (success.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(CheckCircle2), { class: "w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" }),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(success.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSubmit, ["prevent"]),
              class: "p-6 space-y-6"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_11, [
                  _createVNode(_unref(User), { class: "w-4 h-4" }),
                  _cache[23] || (_cache[23] = _createTextVNode(" Informations de base "))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, [
                      _createTextVNode(" Email "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
                      type: "email",
                      required: "",
                      onInput: generateUsername,
                      class: "w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                      placeholder: "ex: john.doe@example.com"
                    }, null, 544), [
                      [_vModelText, form.value.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", { class: "flex items-center gap-1 text-sm font-medium text-dashboard-text mb-2" }, [
                      _createTextVNode(" Nom d'utilisateur "),
                      _createElementVNode("span", { class: "text-xs text-dashboard-muted italic" }, "(généré automatiquement)")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.username) = $event)),
                      type: "text",
                      readonly: "",
                      class: "w-full px-3 py-2 bg-gray-100 border border-dashboard-border rounded-lg text-sm text-dashboard-muted cursor-not-allowed",
                      placeholder: "Sera généré depuis l'email"
                    }, null, 512), [
                      [_vModelText, form.value.username]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, [
                      _createTextVNode(" Prénom "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.first_name) = $event)),
                      type: "text",
                      required: "",
                      class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                      placeholder: "ex: John"
                    }, null, 512), [
                      [_vModelText, form.value.first_name]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, [
                      _createTextVNode(" Nom "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.last_name) = $event)),
                      type: "text",
                      required: "",
                      class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                      placeholder: "ex: Doe"
                    }, null, 512), [
                      [_vModelText, form.value.last_name]
                    ])
                  ]),
                  (!_ctx.userId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", null, [
                          _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, [
                            _createTextVNode(" Mot de passe "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.password) = $event)),
                            type: "password",
                            required: "",
                            class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                            placeholder: "Entrer le mot de passe"
                          }, null, 512), [
                            [_vModelText, form.value.password]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, [
                            _createTextVNode(" Confirmer le mot de passe "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.confirm_password) = $event)),
                            type: "password",
                            required: "",
                            class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                            placeholder: "Confirmer le mot de passe"
                          }, null, 512), [
                            [_vModelText, form.value.confirm_password]
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_14, [
                  _createVNode(_unref(Briefcase), { class: "w-4 h-4" }),
                  _cache[30] || (_cache[30] = _createTextVNode(" Rôle et organisation "))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, [
                      _createTextVNode(" Rôle "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.profile.role_id) = $event)),
                      required: "",
                      class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20"
                    }, [
                      _cache[31] || (_cache[31] = _createElementVNode("option", { value: "" }, "Sélectionner un rôle", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRoles.value, (role) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: role.id,
                          value: role.id
                        }, _toDisplayString(role.nom) + " (" + _toDisplayString(role.code) + ") ", 9, _hoisted_16))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, form.value.profile.role_id]
                    ])
                  ]),
                  (!isAmbassadeScopedAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, " Direction ", -1)),
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((searchDirection).value = $event)),
                            type: "text",
                            onFocus: _cache[8] || (_cache[8] = ($event: any) => (showDirectionDropdown.value = true)),
                            onInput: _cache[9] || (_cache[9] = ($event: any) => (showDirectionDropdown.value = true)),
                            disabled: isDirectionScopedAdmin.value,
                            placeholder: isDirectionScopedAdmin.value ? 'Direction de votre périmètre' : 'Rechercher une direction...',
                            class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20 disabled:opacity-70 disabled:cursor-not-allowed"
                          }, null, 40, _hoisted_19), [
                            [_vModelText, searchDirection.value]
                          ]),
                          _createVNode(_unref(Search), { class: "absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-dashboard-muted pointer-events-none" })
                        ]),
                        (showDirectionDropdown.value && filteredDirectionsSearch.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDirectionsSearch.value, (dir) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: dir.id,
                                  type: "button",
                                  onClick: ($event: any) => (selectDirection(dir)),
                                  class: "w-full text-left px-3 py-2 hover:bg-[#22282F]/10 transition-colors text-sm border-b border-dashboard-border last:border-b-0"
                                }, [
                                  _createElementVNode("div", _hoisted_22, _toDisplayString(dir.nom), 1),
                                  _createElementVNode("div", _hoisted_23, _toDisplayString(dir.code), 1)
                                ], 8, _hoisted_21))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (selectedDirection.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createVNode(_unref(Briefcase), { class: "w-3 h-3" }),
                              _createElementVNode("span", null, _toDisplayString(selectedDirection.value.nom), 1),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: clearDirection,
                                class: "hover:bg-[#22282F]/20 rounded-full p-0.5"
                              }, [
                                _createVNode(_unref(X), { class: "w-3 h-3" })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!isAmbassadeScopedAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, " Département ", -1)),
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((searchDepartement).value = $event)),
                            type: "text",
                            onFocus: _cache[11] || (_cache[11] = ($event: any) => (showDepartementDropdown.value = true)),
                            onInput: _cache[12] || (_cache[12] = ($event: any) => (showDepartementDropdown.value = true)),
                            disabled: !form.value.profile.direction_id,
                            placeholder: "Rechercher un département...",
                            class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20 disabled:opacity-50 disabled:cursor-not-allowed"
                          }, null, 40, _hoisted_27), [
                            [_vModelText, searchDepartement.value]
                          ]),
                          _createVNode(_unref(Search), { class: "absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-dashboard-muted pointer-events-none" })
                        ]),
                        (showDepartementDropdown.value && filteredDepartementsSearch.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDepartementsSearch.value, (dept) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: dept.id,
                                  type: "button",
                                  onClick: ($event: any) => (selectDepartement(dept)),
                                  class: "w-full text-left px-3 py-2 hover:bg-[#22282F]/10 transition-colors text-sm border-b border-dashboard-border last:border-b-0"
                                }, [
                                  _createElementVNode("div", _hoisted_30, _toDisplayString(dept.nom), 1),
                                  _createElementVNode("div", _hoisted_31, _toDisplayString(dept.code), 1)
                                ], 8, _hoisted_29))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (selectedDepartement.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createVNode(_unref(Building2), { class: "w-3 h-3" }),
                              _createElementVNode("span", null, _toDisplayString(selectedDepartement.value.nom), 1),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: clearDepartement,
                                class: "hover:bg-[#22282F]/20 rounded-full p-0.5"
                              }, [
                                _createVNode(_unref(X), { class: "w-3 h-3" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!form.value.profile.direction_id)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Sélectionnez d'abord une direction "))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!isAmbassadeScopedAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, " Service ", -1)),
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((searchService).value = $event)),
                            type: "text",
                            onFocus: _cache[14] || (_cache[14] = ($event: any) => (showServiceDropdown.value = true)),
                            onInput: _cache[15] || (_cache[15] = ($event: any) => (showServiceDropdown.value = true)),
                            disabled: !form.value.profile.direction_id,
                            placeholder: "Rechercher un service...",
                            class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20 disabled:opacity-50 disabled:cursor-not-allowed"
                          }, null, 40, _hoisted_36), [
                            [_vModelText, searchService.value]
                          ]),
                          _createVNode(_unref(Search), { class: "absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-dashboard-muted pointer-events-none" })
                        ]),
                        (showServiceDropdown.value && filteredServicesSearch.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredServicesSearch.value, (service) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: service.id,
                                  type: "button",
                                  onClick: ($event: any) => (selectService(service)),
                                  class: "w-full text-left px-3 py-2 hover:bg-[#22282F]/10 transition-colors text-sm border-b border-dashboard-border last:border-b-0"
                                }, [
                                  _createElementVNode("div", _hoisted_39, _toDisplayString(service.nom), 1),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createTextVNode(_toDisplayString(service.code) + " ", 1),
                                    (service.departement)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, " • " + _toDisplayString(service.departement.nom), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 8, _hoisted_38))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (selectedService.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _createVNode(_unref(Building2), { class: "w-3 h-3" }),
                              _createElementVNode("span", null, _toDisplayString(selectedService.value.nom), 1),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: clearService,
                                class: "hover:bg-[#22282F]/20 rounded-full p-0.5"
                              }, [
                                _createVNode(_unref(X), { class: "w-3 h-3" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!form.value.profile.direction_id)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_43, " Sélectionnez d'abord une direction "))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, " Matricule ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.profile.matricule) = $event)),
                      type: "text",
                      class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                      placeholder: "ex: MAT-2024-001"
                    }, null, 512), [
                      [_vModelText, form.value.profile.matricule]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, " Téléphone ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.profile.telephone) = $event)),
                      type: "tel",
                      class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                      placeholder: "ex: +229 XX XX XX XX"
                    }, null, 512), [
                      [_vModelText, form.value.profile.telephone]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block text-sm font-medium text-dashboard-text mb-2" }, " Poste ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.profile.poste) = $event)),
                      type: "text",
                      class: "w-full px-3 py-2 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20",
                      placeholder: "ex: Chargé de mission"
                    }, null, 512), [
                      [_vModelText, form.value.profile.poste]
                    ])
                  ])
                ])
              ]),
              (canManagePermissions.value && permsCatalog.value.sections.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("h3", _hoisted_45, [
                      _createVNode(_unref(Settings), { class: "w-4 h-4" }),
                      _cache[39] || (_cache[39] = _createTextVNode(" Permissions backoffice "))
                    ]),
                    _cache[40] || (_cache[40] = _createElementVNode("p", { class: "text-xs text-dashboard-muted mb-4" }, " Tout décoché = accès complet selon le rôle. Cochez des sections pour créer un profil restreint (ex. support) : il ne verra que ces onglets, et les actions non cochées seront désactivées. ", -1)),
                    _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-xs font-medium text-dashboard-text mb-2" }, "Sections visibles", -1)),
                    _createElementVNode("div", _hoisted_46, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permsCatalog.value.sections, (s) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: s.key,
                          class: "flex items-center gap-2 text-sm cursor-pointer"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: s.key,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.profile.backoffice_permissions.sections) = $event)),
                            class: "w-4 h-4 text-[#22282F] border-dashboard-border rounded focus:ring-2 focus:ring-[#22282F]/20"
                          }, null, 8, _hoisted_47), [
                            [_vModelCheckbox, form.value.profile.backoffice_permissions.sections]
                          ]),
                          _createTextVNode(" " + _toDisplayString(s.label), 1)
                        ]))
                      }), 128))
                    ]),
                    _cache[42] || (_cache[42] = _createElementVNode("p", { class: "text-xs font-medium text-dashboard-text mb-2" }, "Actions autorisées (Utilisateurs)", -1)),
                    _createElementVNode("div", _hoisted_48, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permsCatalog.value.actions, (a) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: a.key,
                          class: "flex items-center gap-2 text-sm cursor-pointer"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: a.key,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.profile.backoffice_permissions.actions) = $event)),
                            class: "w-4 h-4 text-[#22282F] border-dashboard-border rounded focus:ring-2 focus:ring-[#22282F]/20"
                          }, null, 8, _hoisted_49), [
                            [_vModelCheckbox, form.value.profile.backoffice_permissions.actions]
                          ]),
                          _createTextVNode(" " + _toDisplayString(a.label), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_50, [
                  _createVNode(_unref(Settings), { class: "w-4 h-4" }),
                  _cache[43] || (_cache[43] = _createTextVNode(" Statut du compte "))
                ]),
                (_ctx.userId)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_51, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.is_active) = $event)),
                        type: "checkbox",
                        class: "w-5 h-5 text-[#22282F] border-dashboard-border rounded focus:ring-2 focus:ring-[#22282F]/20"
                      }, null, 512), [
                        [_vModelCheckbox, form.value.is_active]
                      ]),
                      _cache[44] || (_cache[44] = _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "text-sm font-medium text-dashboard-text" }, "Compte actif"),
                        _createElementVNode("p", { class: "text-xs text-dashboard-muted" }, "L'utilisateur peut se connecter et accéder au système")
                      ], -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: handleClose,
                  class: "flex-1 px-4 py-2.5 bg-dashboard-bg border border-dashboard-border text-dashboard-text rounded-lg text-sm font-medium hover:bg-dashboard-border/50 transition-colors"
                }, " Annuler "),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: loading.value,
                  class: "flex-1 px-4 py-2.5 bg-[#22282F] text-white rounded-lg text-sm font-medium hover:bg-[#22282F]/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                }, [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_unref(Loader2), {
                        key: 0,
                        class: "w-4 h-4 animate-spin"
                      }))
                    : (_openBlock(), _createBlock(_unref(Save), {
                        key: 1,
                        class: "w-4 h-4"
                      })),
                  _createTextVNode(" " + _toDisplayString(_ctx.userId ? 'Mettre à jour' : 'Créer'), 1)
                ], 8, _hoisted_53)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})